<template>
  <div style="height: 100%;">
    <div style="width: 100%;">
      <div style="padding-left:10px;">
        <div v-for="(item, index) in fixedEvaluteSets_copy" v-bind:key="index" style="padding-top: 5px;">
          <span style="padding-right:10px;">选项{{index + 1}}:</span>
          <el-input v-model="item.message" :placeholder="item.message" style="width:250px;" maxlength="20" />
          <el-select multiple collapse-tags v-model='item.grades' style="max-width:240px;" placeholder="触发评价等级">
            <el-option v-for='item0 in evaluateGradeList' :key='item0.rate' :label='item0.rateName' :value='item0.rate'></el-option>
          </el-select>
          <el-button type="text" size="mini" @click="deleteByIdx(index)">
            <svg class="icon icon-delete" aria-hidden="true">
              <use xlink:href="#icontable-delete" />
            </svg>
          </el-button>
        </div>
        <el-row style="padding-top: 15px;">
          <el-col :span="5">
            <el-button type="primary" @click="add()">
              <svg class="icon icon-bianji" aria-hidden="true" style="width:8px;">
                <use xlink:href="#iconzengjia" />
              </svg>
            </el-button>
          </el-col>
        </el-row>
      </div>
      <el-row type="flex" justify="center" style="padding-top:20px;">
        <el-button size="medium" @click="cancel()">取消</el-button>
        <el-button size="medium" type="primary" @click="submit()">确定</el-button>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      fixedEvaluteSets_copy: []
    }
  },
  props: {
    fixedEvaluteSets: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    evaluateGradeList: {
      type: Array,
      required: true,
      default() {
        return []
      }
    }
  },
  mounted() {
    this.fixedEvaluteSets_copy = [...this.fixedEvaluteSets]
  },
  computed: {
  },
  methods: {
    add() {
      this.fixedEvaluteSets_copy.push({ message: '', grades: [] })
    },
    cancel() {
      this.fixedEvaluteSets_copy = [...this.fixedEvaluteSets]
      this.$emit('closeFixedEvaluteSet')
    },
    submit() {
      if (this.fixedEvaluteSets_copy.filter(cp => cp.message).length !== this.fixedEvaluteSets_copy.length ||
        this.fixedEvaluteSets_copy.filter(cp => cp.grades.length > 0).length !== this.fixedEvaluteSets_copy.length) {
        this.$message.warning('调查选项内容或者触发评价等级不能为空')
        return false
      }
      this.$emit('closeFixedEvaluteSet', [...this.fixedEvaluteSets_copy])
    },
    deleteByIdx(idx) {
      this.fixedEvaluteSets_copy.splice(idx, 1)
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}
.el-input {
  width: 100%;
}
.search-form.el-form {
  display: flex;
  justify-content: flex-start;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
.selectInput {
  line-height: inherit;
}
.el-form-item {
  position: relative;
  ::v-deep .el-form-item__label {
    height: 40px;
    line-height: 40px !important;
  }
  .input-border {
    ::v-deep .el-input__inner {
      padding-left: 5px;
      padding-top: 5px;
      padding-bottom: 5px;
      border-radius: 5px;
      border-bottom: 1px solid #dcdfe6;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      &:focus {
        border-bottom: 1px solid #409eff;
      }
    }
  }
  .icon-delete {
    color: #f66f6a;
  }
}

.table-page {
  // margin: 20px 0;
}

.el-dialog .el-dialog__body .el-button + .el-button {
  margin-left: 10px;
}

.el-form .el-form-item[data-v-3da85692] .el-form-item__content .el-row {
  width: 100%;
}
</style>
<style lang="scss">
.el-textarea__inner {
  resize: none !important;
}
.el-pagination.is-background .el-pagination__editor.el-input {
  width: 30px !important;
}
</style>
